var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdui-radio-group"},_vm._l((_vm.options),function(opt){return _c('mdui-radio',{key:_vm.getValue(opt),attrs:{"name":_vm.groupName,"value":_vm.getValue(opt),"checked":_vm.value === _vm.getValue(opt),"disabled":_vm.disabled},on:{"change":checked => _vm.select(checked, opt)}},[_vm._v(_vm._s(_vm.getText(opt)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }